import * as React from 'react';
import { Redirect, useLocation, Switch } from 'react-router-dom';
import { makeRoutes } from './routes';
import { parseQueryToKeyedStrings } from './module';
import { useSelector } from 'react-redux';
import { AppState } from '../core/redux/appState';
import { strictEquals } from '../language/module';


/**
 * OldRouteInterceptor: a component that intercepts users coming in on old routes (routes used in the old portal app)
 * and redirects those old routes to the correct new routes.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const OldRouteInterceptor: React.FC = () => {
  const location = useLocation();

  const queryParams = React.useMemo(
    () => parseQueryToKeyedStrings<any>(location.search),
    [location.search],
  );

  const participantId = useSelector<AppState, number>(state => state.auth.currentUser?.personId ?? 0, strictEquals);

  // TODO: deal with:
  //     * /RaterApproval/
  //     * /ReportRecipient/
  //     * login with query params
  const routes = React.useMemo(
    () => makeRoutes(`${queryParams.participantid ?? participantId}`, `${queryParams.projectid}`),
    [participantId, queryParams],
  );

  return (
    <React.Fragment>
      <Switch>
        <Redirect
          from='*/Ymca/Login.aspx'
          to={{
            pathname: routes.YmcaLogin,
            search:   location.search,
          }}
        />
        <Redirect
          from='*/RaterApproval/Login.aspx'
          to={{
            pathname: routes.RaterApprovalLogin,
            search:   location.search,
          }}
        />
        <Redirect
          from='*/ReportRecipient/Login.aspx'
          to={{
            pathname: routes.ReportRecipientLogin,
            search:   location.search,
          }}
        />
        <Redirect
          from='*/Login.aspx'
          to={{
            pathname: routes.Login,
            search:   location.search,
          }}
        />
        <Redirect
          from='*/RaterApproval/ForgotPassword.aspx'
          to={{
            pathname: routes.RaterApprovalForgotPassword,
            search:   location.search,
          }}
        />
        <Redirect
          from='*/ReportRecipient/ForgotPassword.aspx'
          to={{
            pathname: routes.ReportRecipientForgotPassword,
            search:   location.search,
          }}
        />
        <Redirect
          from='*/ForgotPassword.aspx'
          to={{
            pathname: routes.ForgotPassword,
            search:   location.search,
          }}
        />
        <Redirect
          from='*/SetGoalsStep.aspx'
          to={{
            pathname: routes.SetGoals,
          }}
        />
        <Redirect
          from='*/AccountSetup/Passkey.aspx'
          to={{
            pathname: routes.AccountSetup,
            search:   location.search,
          }}
        />
        <Redirect
          from='*/FollowUpSurveyStep.aspx'
          to={{
            pathname: routes.CreateSurvey,
          }}
        />
        <Redirect
          from='*/Project.aspx'
          to={{
            pathname: routes.Project,
          }}
        />
        <Redirect
          from='*/AddDevelopmentGoals.aspx'
          to={{
            pathname: routes.AddPlanItem,
          }}
        />
        <Redirect
          from='*/DevelopmentPlanStep.aspx'
          to={{
            pathname: routes.DevPlan,
          }}
        />
        <Redirect
          from='*/InviteRatersStep.aspx(.*)?#invite'
          to={{
            pathname: routes.InviteRaters,
          }}
        />
        <Redirect
          from='*/InviteRatersStep.aspx(.*)?#remind'
          to={{
            pathname: routes.RemindRaters,
          }}
        />
        <Redirect
          from='*/InviteRatersStep.aspx'
          to={{
            pathname: routes.InviteRaters,
          }}
        />
        <Redirect
          from='*/Survey/Survey'
          to={{
            pathname: routes.SelfSurvey,
          }}
        />
        <Redirect
          from='*/FeedBackReportStep.aspx'
          to={{
            pathname: routes.FeedbackReport,
          }}
        />
        <Redirect
          from='*/copyright'
          to={{
            pathname: routes.Copyright,
          }}
        />
        <Redirect
          from='*/privacy'
          to={{
            pathname: routes.Privacy,
          }}
        />
      </Switch>
    </React.Fragment>
  );
};


export default OldRouteInterceptor;
